<template>
  <div :id="'cont_' + formProperty.nativename" :class="getCompCSS(volatile)">

    <q-input :label="getTitle()" :placeholder="formProperty.infoTextHint" debounce="500" :prefix="formProperty.titlePrefix" :suffix="formProperty.titleSuffix"
             :maxlength="formProperty.lengthMax" bottom-slots :error="propertyHasError" :error-message="getErrorLabel()"
             v-model.number="value" :autofocus="formProperty.autofocus" @update:model-value="onChange" type="text" pattern="[0-9]*|-[0-9]*"
             :hint="getHint()" hide-hint @keydown="keyhandler" :dense="volatile || compressed" :class="'fld' + formProperty.nativename + ' ' + formProperty.cssClass"
             :clearable="readOnly?false:true" :filled="true" :readonly="formProperty.readonly || readOnly"
             :id="formProperty.nativename" :ref="formProperty.nativename">

      <template #append v-if="formProperty.ocrType>0">
        <q-icon name="ion-qr-scanner" class="cursor-pointer" @click="ocrInitLoading=true;showOCRDlg?showOCRDlg=false:showOCRDlg=true"/>
      </template>
    </q-input>

    <!--
        <q-field v-if="formProperty.readonly && !readOnly" readonly="readonly" :label="formProperty.title" stack-label :dense="volatile || compressed" borderless filled :error="propertyHasError"
                 :error-message="formProperty.errorMsg" bg-color="grey-1" :class="formProperty.cssClass + ' txtMemoField'">
          <template v-slot:control>
            <div v-html="formProperty.value"/>
          </template>
        </q-field>
    -->

    <!--
        <div v-else-if="readOnly" class="roRow">
          <span class="roLabel" v-html="getTitle() + ':'"></span>
          <span class="roValue" v-html="value"></span>
        </div>
    -->
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import {maxLength, maxValue, minLength, minValue, requiredIf} from '@vuelidate/validators'
import {fldComponentsMixin} from './mixins/fldComponent'
import {getValueOrCleanNull} from "./formsHelper";
import {StaticData} from '../../classes/StaticData'
import {setCssVar} from 'quasar'
import {useAuthStore} from 'src/stores/AuthStore.js'

export default {
  mixins: [fldComponentsMixin],
  props: [
    'formProperty',
    'queryID',
    'volatile',
    'compressed',
    'readOnly'
  ],
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      StaticData,
      value: this.getValue()
    }
  },
  computed: {
    propertyHasError() {
      return (this.v$.value.$error && !this.v$.$errors.map(err => err.$validator).includes('requiredIf')) || this.formProperty.invalid
    }
  },
  validations() {
    return this.getValidations()
  },
  watch: {
    value: function () {
      this.formProperty.value = getValueOrCleanNull(this.value, this.formProperty)
    },
    formProperty: {
      handler: function (newVal) {
        this.value = newVal.value
      },
      deep: false
    }
  },
  methods: {
    keyhandler: function (event) {
      switch (event.key) {
        case "+":
        case ",":
        case ".":
          event.preventDefault();
      }
    },
    getValidations() {
      let result = {value: {}}

      //logger.info("validate number: min: ", this.formProperty.iValueMin, ", max: ", this.formProperty.iValueMax,
      //    ", lengthMin:", this.formProperty.lengthMin, ", lengthMax:", this.formProperty.iValueMax)

      result.value['minValue'] = minValue(this.formProperty.valueMin)
      if (this.formProperty.valueMax > 0) result.value['maxValue'] = maxValue(this.formProperty.valueMax)
      else result.value['maxValue'] = maxValue(999999999)

      result.value['minLength'] = minLength(this.formProperty.lengthMin)
      if (this.formProperty.lengthMax > 0) result.value['maxLength'] = maxLength(this.formProperty.lengthMax)
      else result.value['maxLength'] = maxLength(10)

      result.value['isValidGen'] = () => {  // generell invalid flag (triggered from extern)
        if (!this.formProperty.invalid) return true;
        return !this.formProperty.invalid
      }

      result.value['requiredIf'] = requiredIf(() => {
        if (this.formProperty.masterPropertyMode === StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE) {
          return (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) && this.formProperty.showThroughDependency === true
        } else {
          return this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.EAGER || this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY
        }
      })

      return result
    },
    onChange(value) {
      if (typeof value === "string") {
        value = value.trim()
      }
      this.formProperty.invalid = false
      this.v$.$touch()
      this.value = value
      this.formProperty.value = value
      this.setErrorBrandColor()

      // todo: only in formulars
      this.$emit('onChange', {
        classID: this.formProperty.classID,
        parentClassID: this.formProperty.parentFormPointer?.classID,
        nativename: this.formProperty.nativename,
        deleteDependentFields: false,
        value: this.value
      })  // send onChange event to parent (formular or parameter)
      if (this.$route.name === StaticData.ROUTE_NAMES.FORMULAR) {
        this.eventBus.formularEdited()
      }
      if (this.volatile && (this.formProperty.instantRefresh || this.formProperty.instantRefresh === undefined)) {
        this.$emit('onEnter')  // submit volatile parameters for immediate refresh
      }
    },
    getValue() {
      const authStore = useAuthStore()
      let result = this.formProperty.value
      let propertyName = this.formProperty.name ? this.formProperty.name : this.formProperty.nativename
      let storedValue = localStorage.getItem(this.queryID + "__" + propertyName)
      let deepLinkParamValue = authStore.queryParamListFromDeepLink[this.formProperty.nativename]

      if (deepLinkParamValue) {
        // parameter value, given as request parameter (e.g.: qp.name), set in store in router beforeEach
        result = deepLinkParamValue
        this.formProperty.value = deepLinkParamValue
        //delete authStore.queryParamListFromDeepLink[this.formProperty.nativename] // delete after one use from store
      } else if (storedValue != null && !this.formProperty.systemParameter) {
        result = getValueOrCleanNull(storedValue, this.formProperty)
      } else if (!this.formProperty.value && this.formProperty.defaultValue) {
        result = this.formProperty.defaultValue
        this.formProperty.value = result
      }
      return result
    },
    getErrorLabel() {
      let result = ""
      const errors = this.v$.$errors.map(err => err.$validator)
      let dispMin = this.formProperty.valueMin
      let dispMax = this.formProperty.valueMax

      if (errors.includes("requiredIf")) {
        result = this.formProperty.infoRequired && this.formProperty.infoRequired !== "" ? this.formProperty.infoRequired : "Feld muss befüllt werden."
      } else if (errors.includes("minValue") || errors.includes("maxValue")) {
        result = "Ungültiger Wert, min: " + dispMin + ", max: " + dispMax
      } else if (errors.includes("minLength") || errors.includes("maxLength")) {
        result = "Ungültige Länge, min: " + dispMin + " Zeichen, max: " + dispMax + " Zeichen"
      } else {
        result = this.formProperty.errorMsg
      }
      //logger.info("errorLabel: ", result)
      return result
    },
    setErrorBrandColor() {
      try {
        if (this.formProperty.requiredMode === StaticData.FORM_REQUIRED_MODES.LAZY) {
          setCssVar('negative', '#f57c00', document.getElementById('cont_' + this.formProperty.nativename))
        } else {
          setCssVar('negative', '#c10015', document.getElementById('cont_' + this.formProperty.nativename))
        }
      } catch (e) {
      }
    },

    onRefreshComp(data) {
      if (this.formProperty.parentFormPointer?.classID == data.parentClassID && (data.subtypeCount === undefined || data.subtypeCount === this.formProperty.subtypeCount) &&
        this.formProperty.nativename === data.nativename) {

        if (data.isEventFromParameter && !this.formProperty.isParameter) return

        // only refresh if we have data and it is not a staticTextField without SQL (which never can change)
        if (data.value !== undefined && data.value != null) {

          let myDepToken = this.formProperty.fieldDependencies ? this.formProperty.fieldDependencies.split(";") : ''

          // this component instance is a dependent field of changed field?
          if (myDepToken.includes(data.sourceChangedNativename)) {
            //logger.info("!!! onRefreshComp of ", this.formProperty.title + " triggered.", this.formProperty.nativename, data.value, data.value.length)
            this.value = data.value
            this.formProperty.value = data.value

            if (data.errorMsg) this.formProperty.errorMsg = data.errorMsg
            else this.formProperty.errorMsg = ""
            if (data.errorFetchingData) this.formProperty.errorFetchingData = data.errorFetchingData
            else this.formProperty.errorFetchingData = ""

            if (data.errorMsg || data.errorFetchingData) this.formProperty.invalid = true
            else this.formProperty.invalid = false

            this.$forceUpdate()

            if (this.formProperty.instantRefresh &&
              //(this.formProperty.renderOnFrontend && (this.formProperty.showThroughDependency == true || this.formProperty.masterPropertyMode != StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE))) {
              (this.formProperty.showThroughDependency == true || this.formProperty.masterPropertyMode != StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
              //logger.info("cascade onChange ongoing from ", this.frmProperty.title)
              //logger.info("emit onchange for ", this.formProperty.nativename)
              this.$emit('onChange', {
                classID: this.formProperty.classID,
                parentClassID: this.formProperty.parentFormPointer?.classID,
                id: this.formProperty.ID,
                nativename: this.formProperty.nativename,
                deleteDependentFields: true,
                value: this.value,
                cascadeResolved: data.cascadeResolved === true // server already resolved the cascade - no further compValueChange
              })  // send onChange event to parent (formular or parameter)

            } else {
              this.showSpinner = false
            }
          }
        }
      }
    },

    onAutocompleteApplyButton(data) {
      if (this.formProperty.nativename === data.nativename && (data.subtypeCount === undefined || data.subtypeCount === this.formProperty.subtypeCount)) {
        this.value = data.value
        this.formProperty.value = data.value
        this.formProperty.errorMsg = ""
        this.formProperty.errorFetchingData = ""
        this.formProperty.invalid = false
        this.$forceUpdate()

        if (this.formProperty.instantRefresh && (this.formProperty.showThroughDependency === true || this.formProperty.masterPropertyMode !== StaticData.FORM_MASTERPROPERTY_MODES.VISIBLE)) {
          this.$emit('onChange', {
            classID: this.formProperty.classID,
            parentClassID: this.formProperty.parentFormPointer?.classID,
            nativename: this.formProperty.nativename,
            deleteDependentFields: true,
            value: this.value
          })  // send onChange event to parent (formular or parameter)
        } else {
          this.showSpinner = false
        }
      }
    },
    onSetPropertyValue(data) {
      if (this.formProperty.id === data.formProperty.id &&
        this.formProperty.parentFormPointer?.classID === data.formProperty.parentFormPointer?.classID &&
        (data.formProperty.subtypeCount === undefined || data.formProperty.subtypeCount === this.formProperty.subtypeCount)) {

        //logger.info("------------ set value of " + this.formProperty.title + " to " + data.value)
        // if (this.formProperty.nativename === "prod_1_price_discount") console.log("2:parentClassID:", this.formProperty.parentFormPointer?.classID, "subtypeCount:", data.formProperty.subtypeCount)

        this.value = data.value
        this.formProperty.value = data.value
        // this.formProperty.propertyInstanceValue = data.value
      }
    },
  },
  beforeUnmount() {
    this.eventBus.off('onRefreshComp', this.onRefreshComp)
    this.eventBus.off('onAutocompleteApplyButton', this.onAutocompleteApplyButton)
    this.eventBus.off('onSetPropertyValue', this.onSetPropertyValue)
  },

  mounted: function () {
    this.eventBus.on('onRefreshComp', this.onRefreshComp)
    this.eventBus.on('onAutocompleteApplyButton', this.onAutocompleteApplyButton)
    this.eventBus.on('onSetPropertyValue', this.onSetPropertyValue)

    this.formProperty.validate = () => {
      this.v$.$reset()
      this.v$.$touch()
      this.formProperty.invalid = this.v$.value.$error
      this.setErrorBrandColor()
      if (this.formProperty.errorFetchingData != "") {
        this.formProperty.errorMsg = this.formProperty.errorFetchingData
        this.formProperty.invalid = true
      }
    }

    this.formProperty.setValid = () => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // bug? - rerender field & errorstats
      this.formProperty.errorMsg = ""
      this.formProperty.invalid = false
      this.v$.$reset()
    }

    this.formProperty.setError = (errMsg) => {
      let tmp = this.value;
      this.value = "";
      this.value = tmp // bug? - rerender field & errorstats
      this.formProperty.errorMsg = errMsg
      this.formProperty.invalid = true
      this.v$.$touch()
    }

    // Initial error? This can be if the field has SQL enabled content...
    if (this.formProperty.errorFetchingData && this.formProperty.errorFetchingData != "") {
      this.formProperty.setError(this.formProperty.errorFetchingData)
    }

    // send onChange event to parent (formular or parameter)
    if (!this.formProperty.noInitOnChange && !this.formProperty.objInstanceID) {
      this.$emit('onChange', {
        classID: this.formProperty.classID,
        parentClassID: this.formProperty.parentFormPointer?.classID,
        nativename: this.formProperty.nativename,
        deleteDependentFields: false,
        value: this.value
      })
    }
  }
}
</script>

<style lang="sass">
.q-field-label
  font-weight: bold

.r_field
  padding: 5px

  .r_title
    font-size: 12px
    display: block

  .r_error
    color: var(--q-color-negative)

    font-size: 12px
    line-height: 1

  //.q-field--dense .q-field__label
  //  top: 6px

  .q-field--dense
    font-size: 13px

  .q-field--dense .q-field__bottom
    padding-top: 2px
</style>
